import React, {ReactElement} from 'react';
import StyledRadioLabel from './styles';
import Props from './typings';

const RadioButton = ({
  checked,
  value,
  label,
  group,
  style = 'text',
  disabled = false,
  callback,
}: Props): ReactElement => {
  return (
    <StyledRadioLabel
      $checked={checked}
      $disabled={disabled}
      aria-disabled={disabled}
      $style={style}
      $title={label}
    >
      <input type="radio" name={group} checked={checked} onChange={() => callback(value)} />
      {label}
    </StyledRadioLabel>
  );
};

export default RadioButton;
